import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=a51d6f76&scoped=true&"
import script from "./coming-soon.vue?vue&type=script&lang=js&"
export * from "./coming-soon.vue?vue&type=script&lang=js&"
import style0 from "./coming-soon.vue?vue&type=style&index=0&id=a51d6f76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51d6f76",
  null
  
)

export default component.exports